import React, { useEffect, useRef, useState } from "react";
import Dashboardmenus from "./Dashboardmenus";
import { authcallApi } from "../../common/API/Api";
import profile_img from "../../../images/profile-img.jpg";
import chatbgImg from "../../../images/water-mark-logo.png";
import { Link, useLocation, useParams } from "react-router-dom";
import { useNotification } from "../../common/Notification";
import { gettimezoneprefrence } from "./commonmodal/Getservertime";
import { convertLocalToUTCFormatted } from "./commonmodal/Formatedtime";
import { getBaseUrl } from "../../common/BaseUrl";
const Supporttiket = () => {
  const { showNotification } = useNotification();
  let base_url = getBaseUrl();
  const { ticket_id, id } = useParams();
  const [updatetimezone, setUpdateTimezone] = useState();
  const [supportalllist, setSupprotalllist] = useState([]);
  const [closesupportlist, setCloseSupportlist] = useState([]);
  const [checknotifications, setChecknotifications] = useState();
  const [editablemsg, setEditablemsg] = useState({
    id: "",
    status: false,
    msg: [],
    upadtedmsg: "",
  });
  const [createrequst, setCreaterequest] = useState({
    message: "",
    attachment: "",
  });
  const fileInputRef = useRef();
  const dropZoneRef = useRef();
  const [ticket, setTicket] = useState();
  const [requestvalid, setRequestvalid] = useState();
  const [supportlist, setSupprotlist] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const intervalRef = useRef(null);
  const location = useLocation();
  const requestdata = (key, value) => {
    setCreaterequest((state) => ({
      ...state,
      [key]: value,
    }));
  };
  const createrequestvalid = (createrequstdata) => {
    let returnvalue = true;
    if (!createrequstdata?.message) {
      setRequestvalid((state) => ({
        ...state,
        message: "Enter message",
      }));
      returnvalue = false;
    } else {
      setRequestvalid((state) => ({
        ...state,
        message: "",
      }));
    }
    if (returnvalue) {
      createsupport(createrequstdata);
    }
  };
  const closeSupport = async (createrequstdata) => {
    try {
      let postdata = {
        support_ticket_id: id,
      };
      const formData = new FormData();
      for (let key in postdata) {
        if (postdata.hasOwnProperty(key)) {
          formData.append(key, postdata[key]);
        }
      }
      let res = await authcallApi(formData, `api/close-support-ticket`, "POST");
      if (res?.data?.success) {
        showNotification(res?.data?.message, "success");
        getsupport();
        getsupportlist();
        getsupportlistclose();
      } else {
        showNotification(res?.data?.message, "error");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const createsupport = async (createrequstdata) => {
    try {
      let postdata = {
        message: JSON.stringify([createrequstdata?.message]),
        attachment: createrequstdata?.attachment
          ? createrequstdata?.attachment
          : "",
        support_ticket_id: id,
      };
      const formData = new FormData();
      for (let key in postdata) {
        if (postdata.hasOwnProperty(key)) {
          formData.append(key, postdata[key]);
        }
      }
      let res = await authcallApi(postdata, `api/reply-support-ticket`, "POST");
      if (res?.data?.success) {
        setChecknotifications(true);
        // showNotification(res?.data?.message , "success")
        getsupport();
        getsupportlist();
        setCreaterequest({
          message: "",
        });
      } else {
        showNotification(res?.data?.message, "error");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getsupport = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/get-support-ticket-replies?support_ticket_id=${id}`,
        "GET",
      );
      if (res?.data?.success) {
        setTicket(res?.data?.ticket);
        const updated = res?.data?.data.map((item) => {
          try {
            JSON.parse(item.message);
            return item;
          } catch (e) {
            return {
              ...item,
              message: JSON.stringify([item.message]),
            };
          }
        });
        setSupprotlist(updated);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const userdetails = async () => {
    try {
      let res = await authcallApi({}, `api/userdetail?type=real`, "GET");
      if (res?.data?.success !== false) {
        setUserDetails(res?.data?.data?.user);
      } else {
        console.error("API error:", res.error);
      }
    } catch (err) {
      console.log(err, "error");
    }
  };
  useEffect(() => {
    const pathToWatch = `${base_url}supportdashboard/${ticket_id}/${id}`;
    const isCorrectPath = location.pathname === pathToWatch;
        console.log(isCorrectPath, "isCorrectPath", pathToWatch)
    if (isCorrectPath) {
      getsupport();
      getsupportlistclose();
      getsupportlist();
      intervalRef.current = setInterval(() => {
        getsupport();
        getsupportlist();
      }, 1000);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [location.pathname, ticket_id]);
  useEffect(() => {
    userdetails();
  }, []);
  const uploadimage = async (image) => {
    const file = image[0];
    let obj = { image: file, type: "support" };
    try {
      const formData = new FormData();
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          formData.append(key, obj[key]);
        }
      }
      let postdata = formData;
      let res = await authcallApi(postdata, `api/setimage`, "POST");
      if (res?.data?.success) {
        requestdata("attachment", res?.data?.path);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const handleFiles = (files) => {
    const uploadedFile = files[0];
    if (uploadedFile) {
      uploadimage(files);
    }
  };
  useEffect(() => {
    const scrollEl = dropZoneRef.current;
    if (scrollEl) {
      scrollEl.scrollTop = scrollEl.scrollHeight;
      // Or smooth scroll: endRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [supportlist?.length]);
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer.files.length > 0) {
      handleFiles(e.dataTransfer.files);
    }
  };

  const handlePaste = (e) => {
    const items = e.clipboardData.items;
    for (let item of items) {
      if (item.kind === "file") {
        const blob = item.getAsFile();
        handleFiles([blob]);
        break;
      }
    }
  };

  useEffect(() => {
    const zone = dropZoneRef.current;
    const preventDefaults = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };
    ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
      zone.addEventListener(eventName, preventDefaults, false);
    });
    const onDragEnter = () => setIsDragging(true);
    const onDragLeave = () => setIsDragging(false);
    zone.addEventListener("dragenter", onDragEnter);
    zone.addEventListener("dragleave", onDragLeave);
    zone.addEventListener("drop", handleDrop);
    window.addEventListener("paste", handlePaste, false);
    return () => {
      ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
        zone.removeEventListener(eventName, preventDefaults);
      });
      zone.removeEventListener("drop", handleDrop);
      window.removeEventListener("paste", handlePaste);
    };
  }, []);
  const getsupportlist = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/get-support-ticket?page=1&type=open`,
        "GET",
      );
      if (res?.data?.success) {
        if (res?.data?.data?.length) {
          let arr1 = [];
          let arr2 = [];
          res?.data?.data.forEach((result) => {
            if (result?.status !== "close") {
              arr1.push(result);
            } else {
              arr2.push(result);
            }
          });
          const idsWithCount = arr1
            ?.filter((item) => item?.count > 0)
            .map((item) => item?.id);
          const isMatch = idsWithCount.includes(parseInt(id));
          if (isMatch && window.innerWidth > 768) {
            supportmegcount(id);
          }
          setSupprotalllist(arr1);
        } else {
          setSupprotalllist([]);
        }
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getsupportlistclose = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/get-support-ticket?page=1&type=close`,
        "GET",
      );
      if (res?.data?.success) {
        if (res?.data?.data?.length) {
          let arr1 = [];
          let arr2 = [];
          res?.data?.data.forEach((result) => {
            if (result?.status !== "close") {
              arr1.push(result);
            } else {
              arr2.push(result);
            }
          });
          const idsWithCount = arr1
            ?.filter((item) => item?.count > 0)
            .map((item) => item?.id);
          const isMatch = idsWithCount.includes(parseInt(id));
          if (isMatch && window.innerWidth > 768) {
            supportmegcount(id);
          }
          setCloseSupportlist(arr2);
        }
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const supportmegcount = async (id) => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/support-markseen/${id}`,
        "POST",
      );
      if (res?.data?.success) {
        getsupportlist();
        getsupportlistclose();
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const supportChatMobile = useRef(null);
  const supportChatListMobile = useRef(null);
  const supportChatOpen = () => {
    supportChatMobile.current.classList.add("show");
    supportChatListMobile.current.classList.add("show");
  };

  const supportChatBack = () => {
    supportChatMobile.current.classList.remove("show");
    supportChatListMobile.current.classList.remove("show");
  };

  const openSupportRequestTab = useRef(null);
  const openSupportRequest = (e) => {
    openSupportRequestTab.current.classList.toggle("show");
    e.currentTarget.classList.toggle("show");
  };

  const closeSupportRequestTab = useRef(null);
  const closeSupportRequest = (e) => {
    closeSupportRequestTab.current.classList.toggle("show");
    e.currentTarget.classList.toggle("show");
  };
  const getimezone = async () => {
    const timezonePref = await gettimezoneprefrence();
    setUpdateTimezone(timezonePref);
  };
  useEffect(() => {
    getimezone();
  }, []);

  const posteditmsg = async (id, editmsg) => {
    try {
      editmsg?.msg.push(editmsg?.upadtedmsg);
      let postdata = {
        reply_id: id,
        message: JSON.stringify(editmsg?.msg),
      };
      let res = await authcallApi(postdata, `api/edit-support-reply`, "POST");
      if (res?.data?.success) {
        getsupport();
        setEditablemsg({
          id: "",
          status: false,
          msg: [],
          upadtedmsg: "",
        });
        showNotification(res?.data?.message, "success");
      } else {
        showNotification(res?.data?.message, "error");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const deletemsg = async (id) => {
    try {
      let postdata = {
        reply_id: id,
      };
      let res = await authcallApi(postdata, `api/delete-support-reply`, "POST");
      if (res?.data?.success) {
        getsupport();
        setEditablemsg({
          id: "",
          status: false,
          msg: [],
        });
        showNotification(res?.data?.message, "success");
      } else {
        showNotification(res?.data?.message, "error");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getMessage = (msg) => {
    try {
      let parsed = JSON.parse(msg);
      if (Array.isArray(parsed)) {
        return parsed[parsed.length - 1];
      }
      return msg;
    } catch (e) {
      return msg;
    }
  };
  const checklick = (msg) => {
    if (!msg) return "";

    const urlRegex = /(https?:\/\/[^\s]+)/g;
    if (!urlRegex.test(msg)) {
      return msg;
    }
    return msg.replace(urlRegex, (url) => {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
  };

  const upadtemsg = (result) => {
    let parsjson = JSON.parse(result?.message);
    setEditablemsg({
      id: result?.id,
      status: true,
      msg: parsjson,
      upadtedmsg: parsjson?.[parsjson?.length - 1],
    });
  };
  return (
  
      <React.Fragment>
        <Dashboardmenus
          checknotifications={checknotifications}
          setChecknotifications={setChecknotifications}
        />
        {/* <div className="dashboard-contentbody supportchatUi" style={{backgroundImage: `url(${chatBackgroung})`}}></div> */}
        <div className="dashboard-contentbody supportchatUi">
          <section className="DepositSec">
            <div className="container-fluid">
              <div className="row pb-3" ref={supportChatListMobile}>
                <div class="col-12 openlisthide">
                  <Link
                    className=""
                    to={`${base_url}supportdashboard`}
                    state={{ from: "my_requests" }}
                  >
                    <button className="back_btn mb-0 pb-3">
                      <i class="fa-solid fa-arrow-left-long"></i>
                      <span style={{ marginLeft: "10px" }}>Back</span>
                    </button>
                  </Link>
                </div>
                <div class="col-xl-3 col-lg-4 col-md-4 col-12 dw openlisthide">
                  <div className="SupportTicketNo col">
                    <div className="SupportTickat_list01">
                      <h4
                        class="chat_list_title border-none show"
                        onClick={openSupportRequest}
                      >
                        Open Support Request{" "}
                        <i class="fa-solid fa-chevron-down"></i>
                      </h4>
                      <ul
                        className="SupportTicketNo-list show"
                        ref={openSupportRequestTab}
                      >
                        {supportalllist?.length
                          ? supportalllist.map((result, key) => {
                              return (
                                <li key={key} onClick={supportChatOpen}>
                                  <Link
                                    onClick={() => {
                                      supportmegcount(result?.id);
                                      setCreaterequest((state) => ({
                                        ...state,
                                        attachment: "",
                                        message: "",
                                      }));
                                    }}
                                    to={`${base_url}supportdashboard/${result?.ticket_id}/${result?.id}`}
                                    className={
                                      result?.ticket_id === ticket_id
                                        ? "active"
                                        : ""
                                    }
                                  >
                                    <img src={profile_img} />
                                    <h4>
                                      <strong className="chattime01">
                                        {result?.ticket_id} 
                                         <span>
                                          {
                                          convertLocalToUTCFormatted(
                                            result?.message_last_date,
                                            updatetimezone,
                                          )?.datetime
                                        }
                                         </span>
                                         </strong>
                                      <div>
                                        <span>
                                          {" "}
                                          {getMessage(result?.message_last)}
                                        </span>
                                        
                                         
                                        {result?.count > 0 && (
                                          <span className="chatcounting">
                                            {" "}
                                            {result?.count > 0
                                              ? result?.count
                                              : ""}{" "}
                                          </span>
                                         
                                        )}
                                      
                                        
                                      </div>
                                    </h4>
                                  </Link>
                                </li>
                              );
                            })
                          : ""}
                      </ul>

                      <h4
                        class="chat_list_title show"
                        onClick={closeSupportRequest}
                      >
                        Close Support Request{" "}
                        <i class="fa-solid fa-chevron-down"></i>
                      </h4>
                      <ul
                        className="SupportTicketNo-list show"
                        ref={closeSupportRequestTab}
                      >
                        {closesupportlist?.length
                          ? closesupportlist.map((result, key) => {
                              return (
                                <li onClick={supportChatOpen}>
                                  <Link
                                    to={`${base_url}supportdashboard/${result?.ticket_id}/${result?.id}`}
                                    className={
                                      result?.ticket_id === ticket_id
                                        ? "active"
                                        : ""
                                    }
                                  >
                                    <img src={profile_img} />
                                    <h4>
                                      <strong>{result?.ticket_id}</strong>
                                      <span>
                                        {" "}
                                        {getMessage(result?.message_last)}
                                      </span>
                                    </h4>
                                  </Link>
                                </li>
                              );
                            })
                          : ""}
                      </ul>
                    </div>
                  </div>
                </div>
                <div
                  class="col-xl-7 col-lg-8 col-md-8 col-12 dw support_chat_mobile"
                  ref={supportChatMobile}
                >
                  <div class="chat-card dark-card cardBox p-0">
                    {/* <h4 class="card_title">
                      Support Ticket No: {ticket?.ticket_id}
                    </h4> */}

                    <div class="chat-container">
                      <div class="chat-header">
                        <div className="chatme">
                          <button
                            className="back_btn"
                            onClick={supportChatBack}
                          >
                            <i class="fa-solid fa-arrow-left-long"></i>
                          </button>
                          <img src={profile_img} />
                          <h4 class="chatname">
                            {ticket?.ticket_id}{" "}
                            <span>
                              {ticket?.status === "under consideration"
                                ? "Open"
                                : ticket?.status}
                            </span>
                          </h4>
                        </div>
                        <button
                          class="resolved-btn"
                          onClick={() => closeSupport()}
                        >
                          <svg
                            id="Layer_1"
                            viewBox="0 0 612 792"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            style={{
                              enableBackground: "new 0 0 612 792",
                            }}
                          >
                            <style>{`.st0{fill:#41AD49;}`}</style>
                            <g>
                              <path
                                className="st0"
                                d="M562,396c0-141.4-114.6-256-256-256S50,254.6,50,396s114.6,256,256,256S562,537.4,562,396L562,396z    
            M501.7,296.3l-241,241l0,0l-17.2,17.2L110.3,421.3l58.8-58.8l74.5,74.5l199.4-199.4L501.7,296.3L501.7,296.3z"
                              />
                            </g>
                          </svg>{" "}
                          Mark as solved
                        </button>
                      </div>
                      <div
                        class="chat-body"
                        ref={dropZoneRef}
                        style={{ backgroundImage: `url(${chatbgImg})` }}
                      >
                        {supportlist?.length
                          ? supportlist.map((result, key) => {
                              return (
                                <>
                                  {result?.sender_type === "user" ? (
                                    <div class="message send-message">
                                      {editablemsg?.status &&
                                      editablemsg?.id === result?.id ? (
                                        <div className="">
                                          <div className="editmessage_input">
                                            <textarea
                                              style={{
                                                maxHeight: "50px",
                                                minHeight: "50px",
                                              }}
                                              onChange={(e) =>
                                                setEditablemsg((state) => ({
                                                  ...state,
                                                  upadtedmsg: e.target.value,
                                                }))
                                              }
                                              onKeyDown={(e) => {
                                                if (
                                                  e.key === "Enter" &&
                                                  !e.shiftKey
                                                ) {
                                                  e.preventDefault();
                                                  setEditablemsg((state) => ({
                                                    ...state,
                                                    upadtedmsg: e.target.value,
                                                  }));
                                                  posteditmsg(
                                                    result?.id,
                                                    editablemsg,
                                                  );
                                                }
                                              }}
                                              type="text"
                                              name="edit-message"
                                              placeholder=""
                                              value={editablemsg?.upadtedmsg}
                                              className="form-control"
                                            />
                                            <div className="editmessage_btned">
                                              <button
                                                onClick={() =>
                                                  posteditmsg(
                                                    result?.id,
                                                    editablemsg,
                                                  )
                                                }
                                                type="button"
                                                className="send-btn"
                                              >
                                                <i className="fa-solid fa-check"></i>
                                              </button>
                                              <button
                                                type="button"
                                                onClick={() =>
                                                  setEditablemsg({
                                                    id: "",
                                                    status: false,
                                                    msg: [],
                                                  })
                                                }
                                                className="delete-btn"
                                              >
                                                <i class="fa-solid fa-xmark"></i>
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      ) : (
                                        <>
                                          <p
                                            dangerouslySetInnerHTML={{
                                              __html: checklick(
                                                getMessage(result?.message),
                                              ),
                                            }}
                                          ></p>
                                          {result?.attachment !== null &&
                                          result?.attachment &&
                                          result?.attachment !== "undefined" ? (
                                            <div>
                                              <img
                                                src={`${process.env.REACT_APP_IMAGE_URL}${result.attachment}`}
                                              ></img>
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                        </>
                                      )}

                                      <h4 class="chatname">
                                        {!editablemsg?.status &&
                                          result?.id !== editablemsg?.id &&
                                          ticket?.status !== "close" && (
                                            <div className="editmessage_icon">
                                              <span
                                                onClick={() =>
                                                  upadtemsg(result)
                                                }
                                                tooltip="Edit"
                                              >
                                                <i className="fa-regular fa-pen-to-square"></i>
                                              </span>
                                              {supportlist[0]?.id !==
                                                result?.id && (
                                                <span
                                                  tooltip="Delete"
                                                  onClick={() =>
                                                    deletemsg(result?.id)
                                                  }
                                                >
                                                  <i class="fa-solid fa-trash-can"></i>
                                                </span>
                                              )}
                                            </div>
                                          )}
                                        <span>
                                          {
                                            convertLocalToUTCFormatted(
                                              result?.date,
                                              updatetimezone,
                                            )?.datetime
                                          }
                                        </span>
                                        {result?.sender_type}
                                        <img
                                          src={
                                            userDetails?.image
                                              ? process.env
                                                  .REACT_APP_IMAGE_URL +
                                                userDetails?.image
                                              : profile_img
                                          }
                                        />
                                      </h4>
                                    </div>
                                  ) : (
                                    <div class="message resend-message">
                                      <p
                                        dangerouslySetInnerHTML={{
                                          __html: checklick(
                                            getMessage(result?.message),
                                          ),
                                        }}
                                      ></p>
                                      {result?.attachment !== null &&
                                          result?.attachment &&
                                          result?.attachment !== "undefined" ? (
                                            <div>
                                              <img
                                                src={`${process.env.REACT_APP_IMAGE_URL}${result.attachment}`}
                                              ></img>
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                      <h4 class="chatname">
                                        <img src={profile_img} />
                                        {result?.sender_type}
                                        <span>
                                          {
                                            convertLocalToUTCFormatted(
                                              result?.date,
                                              updatetimezone,
                                            )?.datetime
                                          }
                                        </span>
                                      </h4>
                                    </div>
                                  )}
                                </>
                              );
                            })
                          : ""}
                      </div>
                      <div class="chat-footer chat-footer01">
                        {createrequst?.attachment ? (
                          <div className="uplodetimeattachment">
                            <span>
                              <img
                                src={`${process.env.REACT_APP_IMAGE_URL}${createrequst.attachment}`}
                                download
                                target="_blank"
                                rel="noopener noreferrer"
                              />
                              <button
                                className="removeupload-img"
                                onClick={() =>
                                  setCreaterequest((state) => ({
                                    ...state,
                                    attachment: "",
                                  }))
                                }
                              >
                                <i class="fa-solid fa-xmark"></i>
                              </button>
                            </span>
                          </div>
                        ) : null}
                        {ticket?.status !== "close" && ticket?.status ? (
                          <div
                            class="d-flex "
                            style={{ width: "100%" }}
                            method="POST"
                          >
                            <textarea
                              onChange={(e) =>
                                requestdata("message", e.target.value)
                              }
                              onKeyDown={(e) => {
                                if (e.key === "Enter" && !e.shiftKey) {
                                  e.preventDefault();
                                  createrequestvalid(createrequst);
                                }
                              }}
                              value={createrequst?.message}
                              rows="4"
                              placeholder="Enter your message"
                              required
                              className={
                                requestvalid?.message
                                  ? "border-danger form-control"
                                  : "form-control"
                              }
                            ></textarea>
                            <div className="btnsmassage01">
                              <div className="addfile01">
                                <label
                                  for="addfileId"
                                  // data-bs-toggle="tooltip"
                                  // data-bs-placement="top"
                                  // data-bs-original-title="Attachment"
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title="Attachment"
                                >
                                  <i class="fa-solid fa-plus"></i>
                                  <input
                                    type="file"
                                    id="addfileId"
                                    ref={fileInputRef}
                                    onChange={(e) =>
                                      handleFiles(e.target.files)
                                    }
                                    name="file"
                                    className="form-control"
                                  ></input>
                                </label>
                              </div>

                              {/* <button
                                class="resolved-btn"
                                onClick={() => closeSupport()}
                               
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="Mark as solved"
                              >
                                <i class="fa-solid fa-check-double"></i>
                              </button> */}
                              <div>
                                <button
                                  class="send-btn"
                                  onClick={() =>
                                    createrequestvalid(createrequst)
                                  }
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  data-bs-original-title="Send"
                                >
                                  <i class="fa-regular fa-paper-plane"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        ) : (
                          ticket?.status === "close" && (
                            <p>Support request is closed</p>
                          )
                        )}

                        {requestvalid?.message ? (
                          <p className="text-danger mb-0">
                            {requestvalid?.message}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </React.Fragment>
   
  );
};

export default Supporttiket;
